import React from 'react';
import {
  Typography,
} from '@mui/material';
import {
  Link as LinkIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { KnowledgeItem } from '../../../types';
import DraggableItemsPanel from '../../../shared/components/DraggableItemsPanel';
import ItemCard, { ActionItem } from '../../../shared/components/ItemCard';

interface KnowledgePanelProps {
  knowledgeItems: KnowledgeItem[];
  onViewKnowledgeItem: (item: KnowledgeItem) => void;
  onRemoveKnowledgeItem: (itemId: string) => void;
  onReorderKnowledge: (items: KnowledgeItem[]) => void;
  collapsed?: boolean;
  onToggleCollapse?: () => void;
}

const KnowledgePanel: React.FC<KnowledgePanelProps> = ({
  knowledgeItems,
  onViewKnowledgeItem,
  onRemoveKnowledgeItem,
  onReorderKnowledge,
  collapsed,
  onToggleCollapse,
}) => {
  const renderKnowledgeItem = (item: KnowledgeItem) => {
    const actions: ActionItem[] = [
      {
        id: 'remove',
        label: 'Remove from Investigation',
        icon: <DeleteIcon sx={{ fontSize: 16 }} />,
        onClick: () => onRemoveKnowledgeItem(item.id),
        color: 'error.main',
      },
    ];

    return (
      <ItemCard
        key={item.knowledge_item_id}
        item={item}
        rank={item.rank}
        onViewClick={() => onViewKnowledgeItem(item)}
        renderContent={(i) => (
          <Typography
            variant="body2"
            sx={{
              overflow: 'hidden',
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {i.summary}
          </Typography>
        )}
        statusChips={[]}
        actionMode="menu"
        actions={actions}
      />
    );
  };

  return (
    <DraggableItemsPanel
      title="Relevant Knowledge"
      titleIcon={<LinkIcon color="primary" />}
      subtitle="Drag to reorder by relevance"
      items={knowledgeItems}
      emptyStateIcon={<LinkIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />}
      emptyStateText="No knowledge items yet"
      emptyStateSubtext="Start an investigation to discover relevant knowledge"
      onReorderItems={onReorderKnowledge}
      renderItem={renderKnowledgeItem}
      getItemId={(item) => item.id}
      droppableId="knowledge-items"
      collapsed={collapsed}
      onToggleCollapse={onToggleCollapse}
    />
  );
};

export default KnowledgePanel;